import * as React from 'react';
import { connect } from 'react-redux';

import BaseCampaignPage from '../BaseCampaignPage';
import CampaignPayments from 'modules/campaigns/components/payments/CampaignPayments';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./campaign-payments-page.i18n.json'));

import type { Campaign, Params } from 'types';
import type { Dispatch } from 'redux';

type OwnProps = {
  params: Params
};

type StateProps = {
  campaign: Campaign
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by redux connect
} & OwnProps & StateProps;

const MSG_KEY = 'campaign_payments_page';

const CampaignPaymentsPage = ({
  params,
  campaign
}: Props) => (
  <BaseCampaignPage
    params={params}
    documentTitle={__t(`${MSG_KEY}.document_title`)}
    pageType="payments"
  >
    {
      campaign && campaign.id &&
        <CampaignPayments campaignId={campaign.id} />
    }
  </BaseCampaignPage>
);

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

export default connect(mapStateToProps)(CampaignPaymentsPage);
